@if (service.vm$ | async; as vm) {
  <div
    class="medical-component-search_input"
    [class.medical-component-search_input--dialog]="isDialog"
    [class.medical-component-search_input--open]="isOverlayOpen()">
    <input
      #searchInput
      autocomplete="off"
      data-testid="medical-component-search_input"
      id="medical-component-search_input"
      matInput
      name="searchInput"
      type="text"
      [formControl]="searchText"
      (click)="openOverlay()"
      (focus)="handleInputFocus()"
      (keydown.escape)="onEscape()" />

    @if (filterOptions.useProposedComponent && searchText.value?.length > 0) {
      <mat-icon
        data-testid="medical-component-search_propose-component-button"
        [class]="'medical-component-search_input-add-icon'"
        [class.extra-space]="addOffset"
        [icon]="'plus'"
        [iconSize]="18"
        [ttTooltip]="'ProposeComponent' | transloco"
        (click)="addProposedComponent()" />
    }
  </div>

  <ng-template cdkPortal>
    <div class="medical-component-search_autocomplete">
      @if (filterOptions.possibleComponentTypes.length > 1) {
        <shared-search-filter
          class="medical-component-search_autocomplete-filter"
          [options]="filterOptions"
          [value]="vm.searchOptions?.filter"
          (filterChanged)="filterChanged($event)" />
      }

      <div class="medical-component-search_result-title">{{ 'Results' | transloco }}</div>

      @if (vm.loading) {
        <div class="medical-component-search_result-loading">
          <tt-spinner [size]="16" />
        </div>
      } @else if (searchText.value?.length < minSearchLength) {
        <div class="medical-component-search_result-start-typing">{{ 'StartTypingForResults' | transloco }}</div>
      } @else {
        <div class="medical-component-search_result-list">
          @for (component of vm.searchResults.components; track $index) {
            <button
              ttButton
              variant="transparent"
              [attr.data-testid]="'medical-component-search_result-' + component.code"
              (click)="componentSelected(component)">
              <div class="medical-component-search_result-item">
                <span class="medical-component-search_result-item-title">{{ component.title }}</span>
                <span class="medical-component-search_result-item-component-code">- {{ component.code }}</span>
              </div>
            </button>
          }
          @if (vm.searchResults.proposedComponents?.length > 0) {
            @for (component of vm.searchResults.proposedComponents; track $index) {
              <button
                class="medical-component-search_result-item"
                ttButton
                variant="transparent"
                (click)="componentSelected(component, true)">
                <div class="medical-component-search_result-item">
                  <span class="medical-component-search_result-item-title">{{ component.title }}</span>
                  <span class="medical-component-search_result-item-component-code">- {{ component.code }}</span>
                </div>
              </button>
            }
          }
          @if (!vm.searchResults.components?.length && !vm.searchResults.proposedComponents?.length) {
            <div class="medical-component-search_result-empty">{{ 'NoSearchResults' | transloco }}</div>
          }
        </div>
      }
    </div>
  </ng-template>
}
